import axios from 'axios';
import store from '@/store'

const initialState = () => ({
  survey: {},
  itc_history: []
});

const questionMap = {
  1: 'instructor_experiencia',
  4: 'instructor_ejemplos',
  6: 'instructor_rendimiento',
  7: 'instructor_puntualidad',
  9: 'instructor_comentario',
  10: 'servicios_informacion',
  12: 'servicios_atencion',
  14: 'contenidos_alumni',
  15: 'contenidos_agregar',
  17: 'contenidos_material',
  19: 'balance_expectativas',
  20: 'balance_recomendaria',
  21: 'testimonio',
  22: 'instalaciones_equipamiento',
  23: 'instalaciones_aulas',
  24: 'instalaciones_comunes',
  25: 'instalaciones_comentario',
};

function mapQuestions(questions) {
  const result = {};

  Object.entries(questions).forEach(([id, value]) => {
    if (!(id in questionMap)) return;

    if (
      typeof value === 'number' ||
      (typeof value === 'string' && value.trim() !== '' && !isNaN(value))
    ) {
      result[questionMap[id]] = Number(value);
    } else {
      result[questionMap[id]] = String(value).trim();
    }
  });

  return result;
}

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    RESET_STATE(state){
      state.survey = {}
    },
    SET_SURVEY(state, payload) {
      state.survey = payload
    },
    SET_ITC_HISTORY(state, payload) {
      state.itc_history = payload
    }
  },
  actions: {
    async getSurvey({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const params = {
        contacto_id: store.state.Auth.user.userId,
        calendario_id: args.calendario_id
      }

      try {
        const response = await axios.get(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + 'contactos/encuestas',
          {
            ...options,
            params
          }
        );

        commit('SET_SURVEY', response.data.data[0])
        return response.data.data[0];
      } catch (err) {
        commit('SET_SURVEY', {})
        return {};
      }
    },
    async sendSurvey({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      const params = {
        ...mapQuestions(args.questions),
        contacto_id: store.state.Auth.user.userId,
        calendario_id: args.calendario_id,
        contacto_sucursal_id: 1,
        calendario_sucursal_id: 1,
        profesor_contacto_id: args.profesor_contacto_id,
        contacto_email: store.state.Auth.user.mail
      };

      const response = await axios.post(
        process.env.VUE_APP_EDUCACIONIT_API_SERVER + `contactos/${store.state.Auth.user.userId}/encuestas`,
        params,
        options
      );

      return response.data;
    },
    async getItc({ commit, state }, args) {
      const options = {
        headers:{
          'Authorization': `Bearer ${await store.state.AuthFirebase.auth.currentUser?.getIdToken()}`,
          'Content-Type': 'application/json'
        }
      };

      try {
        const response = await axios.get(
          process.env.VUE_APP_EDUCACIONIT_API_SERVER + `contactos/${store.state.Auth.user.userId}/itc`,
          {
            ...options
          }
        );

        commit('SET_ITC_HISTORY', response.data.data)
        return response.data.data.reduce((sum, item) => sum + item.creditos, 0);
      } catch (err) {
        return 0;
      }
    },
  },
  getters: {
    survey: (state) => state.survey,
    itc_history: (state) => state.itc_history
  },
};
